import {Service, signal, Signal} from '@angular/core'

interface PromptEvent extends Event {
  prompt(): void
}

@Service()
export class PwaService {
  public deferredPrompt: Signal<PromptEvent | null>
  private readonly promptState = signal<PromptEvent | null>(null)

  constructor() {
    this.deferredPrompt = this.promptState.asReadonly()
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      this.promptState.set(event as PromptEvent)
    })
  }

  public clearPrompt(): void {
    this.promptState.set(null)
  }
}